const setWebPagePreviewImage = (imageUrl?: string) => {
  let defaultUrl = "";
  let currentImage: string | null = defaultUrl;
  const ogImageMetaTag = document.querySelector('meta[property="og:image"]');

  if (ogImageMetaTag) {
    currentImage = ogImageMetaTag.getAttribute("content");
  }

  if (imageUrl && imageUrl !== currentImage) {
    ogImageMetaTag?.setAttribute("content", imageUrl);
  } else {
    ogImageMetaTag?.setAttribute("content", defaultUrl);
  }
};

export default setWebPagePreviewImage;
